import React, { useState, useEffect } from "react";
import { SetHeading } from "../../context/NavbarContext";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { getBukUploadHistory } from "../../API  Functions/InventoryFunctions";
import BulkUploadHistoryTable from "../SessionHistory/BulkInventoryHistoryTable";
import BulkCustomerHistoryTable from "../SessionHistory/BulkCustomerHistoryTable";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import {useLocation} from "react-router-dom"

const TABS = [
  { key: "inventory", label: "inventory" },
  { key: "customer", label: "Customer" },
];

const BulkUploadHistory = () => {
  const { t } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const store_id = useSelector((s) => s?.login?.user?.result?.company_id);

  const [loading, setLoading] = useState(false);
  const location = useLocation()
  const [activeTab, setActiveTab] = useState(
  location.state?.tab === "customer" ? "customer" : "inventory"
);
console.log("location.state ==", location.state); // add this line

  const [bulkUploadReport, setBulkUploadReport] = useState([]);
  const [customerBulkUploadHistory, setCustomerBulkUploadHistory] = useState([]);
  const [currentLimit, setCurrentLimit] = useState(10);
  const [currentOffset, setCurrentOffset] = useState(0);

  useEffect(() => {
    GetBulkUploadReport();
    getCustomerBulkUploadHistory();
  }, [currentLimit, currentOffset]);

  const GetBulkUploadReport = async () => {
    const payload = { offset: currentOffset, limit: currentLimit, user_id };
    try {
      setLoading(true);
      const res1 = await getBukUploadHistory(payload);
      if (res1?.result?.status_code === 200) {
        setBulkUploadReport(res1?.result?.response);
      } else {
        setBulkUploadReport([]);
      }
    } catch (error) {
      console.error("Error fetching bulk upload report:", error);
    } finally {
      setLoading(false);
    }
  };

  const getCustomerBulkUploadHistory = async () => {
    const payload = { store_id };
    try {
      setLoading(true);
      const res2 = await axiosInstance.post(URLS.GET_CUSTOMER_BULK_UPLOAD_HISTORY, payload);
      if (res2?.data?.result?.status_code === 200) {
        setCustomerBulkUploadHistory(res2.data.result.response);
      } else {
        setCustomerBulkUploadHistory([]);
      }
    } catch (error) {
      console.error("Error fetching customer bulk upload history:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePagination = (values) => {
    setCurrentLimit(values.limit);
    setCurrentOffset(values.offset);
  };

  return (
    <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto bg-[#ffffff]">
      <SetHeading value="Bulk Import History" />

      <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden ms-3 mt-6">
        {/* Tab Headers */}
        {/* Tab Headers */}
        <div className="w-full border-b border-gray-300 mt-4 mb-6">
          <div className="flex gap-4 overflow-x-auto pb-4">
            {TABS.map((tab) => (
              <div
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`cursor-pointer px-4 py-2 rounded-md font-medium whitespace-nowrap transition-all ${activeTab === tab.key
                  ? "bg-[#E6F0FF] text-[#1D4ED8] border border-[#1D4ED8]"
                  : "text-[#6B7280] hover:bg-gray-100"
                  }`}
              >
                {t(tab.label)}
              </div>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        {activeTab === "inventory" && (
          <BulkUploadHistoryTable
            loading={loading}
            additionalData={bulkUploadReport}
            pagination={handlePagination}
          />
        )}

        {activeTab === "customer" && (
          <BulkCustomerHistoryTable
            loading={loading}
            additionalData={customerBulkUploadHistory}
            pagination={handlePagination}
          />
        )}
      </div>
    </div>
  );
};

export default BulkUploadHistory;